import PropTypes from 'prop-types';

const UserDashboard = ({ children }) => children;

UserDashboard.propTypes = {
  children: PropTypes.node,
};

export default UserDashboard;



// WEBPACK FOOTER //
// ./containers/UserDashboard/component.jsx